import { Check, Circle } from './styles';

export const Checkmark = ({ size = 40 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 40 40" version="1.1">
    <Circle cx="20" cy="20" r="18" />
    <Check points="27 15 20 25 14 21" />
  </svg>
);
